import { createClient, SupabaseClient } from '@supabase/supabase-js'

function isValidUrl(u?: string): u is string {
	return typeof u === 'string' && /^https?:\/\//.test(u)
}

// Cliente Supabase legado (compatibilidade)
// Exportamos `supabase` como `let` para permitir recriar o cliente em runtime
// quando a conexão volta (melhora reconexão do realtime em redes intermitentes).
let supabase: SupabaseClient | any

function buildClient(): SupabaseClient | any {
	const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
	const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

	if (!isValidUrl(supabaseUrl) || !supabaseAnonKey) {
		console.warn('[supabase] Missing or invalid VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Supabase client not initialized.')
		return {
			auth: {
				async getSession() {
					return { data: { session: null } }
				},
				onAuthStateChange(_: any) {
					return () => {}
				},
				async signOut() {
					return {}
				},
			},
		}
	}

	return createClient(supabaseUrl, supabaseAnonKey)
}

// Inicializa na importação
supabase = buildClient()

export function resetSupabase() {
	try {
		console.log('[supabase] resetting client')
		supabase = buildClient()
	} catch (err) {
		console.error('[supabase] error resetting client', err)
	}
}

export { supabase }
